export const useDefaultData = ({helpers}) => {

    const {getCurrentDate} = helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }


    return Object.freeze({
        defaultDataModal
    })
}